/* eslint-disable max-lines */
import { css } from 'linaria';

export const creditBlockImageTop = css`
  width: 100%;
  margin-bottom: 24px;
  
  @media (--from-tablet) {
    display: none;
  }
`;

export const creditBlockTitleWrapper = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 24px;

  @media (--only-tablet) {
    width: 370px;
  }

  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const creditBlock = css`
  background-color: #F4F4F4;
  border-radius: var(--rounding-l);
  display: flex;
  align-items: flex-end;
`;

export const creditBlockInfo = css`
  align-items: center;
  width: 574px;
  padding: 36px 0 36px 24px;

  @media (--only-desktop) {
    width: 454px;
  }

  @media (--only-tablet) {
    padding: 24px 16px;
    width: 370px;
  }

  @media (--only-mobile) {
    width: 100%;
    padding: 24px 16px;
  }
`;

export const creditBlockInfoWrapper = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;

  @media (--to-desktop) {
    margin-bottom: 24px;
  }
`;

export const creditBlockInfoText = css`
  @media (--to-largeDesktop) {
    white-space: break-spaces;
  }

  @media (--only-desktop) {
    line-height: 28px;
  }

  @media (--to-desktop) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const creditBlockPercent = css`
  font-family: LMTitle, Roboto, apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 700;
  font-size: 64px;
  line-height: 56px;
  text-align: end;

  @media (--to-desktop) {
    font-size: 36px;
    line-height: 24px;
  }
`;

export const creditBlockPercentWithOverpayment = css`
  font-size: 44px;
  line-height: 32px;

  @media (--to-desktop) {
    font-size: 26px;
    line-height: 24px;
  }
`;

export const creditBlockOverpaymentText = css`
   @media (--only-tablet) {
    font-size: 13px;
    line-height: 16px;
  }

  @media (--only-mobile) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const creditBlockPeriodList = css`
  && {
    width: 100%;
    background-color: var(--background-primary);
    border-radius: var(--rounding-m);
    padding: 8px;
    justify-content: space-between;
    margin: 0 0 16px 0;

    @media (--only-mobile) {
      padding: 4px;
    }
  }
`;

export const creditBlockPeriodItem = css`
  &&& {
    background-color: white;
    height: 32px;
    margin: 0;
    padding: 2px 12px;

    @media (--only-tablet) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const creditBlockPeriodItemActive = css`
  &&& {
    border: 2px solid var(--control-primary);
  }
`;

export const creditBlockPeriodItemValue = css`
  @media (--only-tablet) {
    font-size: 16px;
    line-height: 24px;
  }

  @media (--only-mobile) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const creditBlockPeriodItemUnit = css`
  margin-left: 5px;

  @media (--to-largeDesktop) {
    display: none;
  }
  
  @media (--only-tablet) {
    font-size: 16px;
    line-height: 24px;
  }

  @media (--only-mobile) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const creditBlockPeriodItemUnitActive = css`
  display: block;
`;

export const creditBlockButton = css`
  && {
    @media (--only-mobile) {
      font-size: 14px;
      line-height: 20px;
      border: unset;
    }
  }
`;

export const creditBlockImage = css`
  height: 231px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 14px;

  @media (--only-desktop) {
    height: 214px;
    margin-bottom: 17px;
  }

  @media (--only-tablet) {
    width: 290px;
    height: 100%;
    margin-bottom: 18px;
  }

  @media (--only-mobile) {
    display: none;
  }
`;
